// Orario "ultimo aggiornamento" in formato relativo + tooltip assoluto.
// `now` è iniettabile per rendere la funzione testabile in modo deterministico.

export interface RelativeTime {
  label: string;
  /** Tooltip assoluto "DD/MM/YYYY HH:MM"; undefined se il timestamp non è valido. */
  title: string | undefined;
}

const pad = (n: number): string => String(n).padStart(2, '0');

export function fmtRelative(iso: string | null, now: Date = new Date()): RelativeTime {
  if (iso === null) return { label: '—', title: undefined };
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return { label: '—', title: undefined };

  const title = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} `
    + `${pad(d.getHours())}:${pad(d.getMinutes())}`;

  const diffMs = now.getTime() - d.getTime();
  const minutes = Math.floor(diffMs / 60_000);
  const hours = Math.floor(diffMs / 3_600_000);

  let label: string;
  if (minutes < 1) {
    label = 'adesso';
  } else if (minutes < 60) {
    label = `${minutes} min fa`;
  } else if (hours < 24) {
    label = hours === 1 ? '1 ora fa' : `${hours} ore fa`;
  } else {
    label = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}`;
  }

  return { label, title };
}
